module.exports = __webpack_public_path__ + "static/media/bike-hover.5b828556.png";